import React from "react";

export const CardQuote = ({quote, text, person}) => {
  return (
    <div class="card">
      <div class="card-header">{quote}</div>
      <div class="card-body">
        <blockquote class="blockquote mb-0">
          <p>{text}</p>
          <footer class="blockquote-footer text-end">
            <cite title="Source Title">{person}</cite>
          </footer>
        </blockquote>
      </div>
    </div>
  );
};
